import {
    request,
    requestPublic
} from './request.js'
// 获取分词管理列表
export function getList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/ArticleWordSegment/GetList',
        method: 'get',
        params: {
            Words: obj.words,
            ReplaceWords: obj.replaceWords,
            pageIndex: obj.pageIndex,
            pageSize: obj.pageSize
        }
    })
}

// 新增
export function add(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/ArticleWordSegment/Add',
        method: 'post',
        data: data
    })
}

// 修改
export function update(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/ArticleWordSegment/Update',
        method: 'post',
        data: data
    })
}

// 删除
export function del(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/ArticleWordSegment/Del',
        method: 'post',
        params: {
            id: id
        }
    })
}